import CONFIG from '../../config';

const actions = {
  averageValue(context, params) {
    context.commit("ADD_LOG", { request: "averageValue" });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint("averageValue"), params.patchParams, {
          // params: params.urlParams,
          headers:
          {
            'Content-Type': 'application/json'
          },
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "averageValue" });
          context.commit('SAVE_APPLICATION_ID', response.data?.application?.id);
          resolve(response.data);
        })
        .catch(err => {
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
          context.commit("REMOVE_LOG", { request: "averageValue" });
        });
    });
  },
  referralStartForGPay(context, params) {
    context.commit("ADD_LOG", { request: "referralStartForGPay" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("referralStartForGPay"), params.formData, {})
        .then(response => {
          context.commit("SAVE_TOKEN", response.data);
          context.commit("PARSE_JWT", response.data?.accessToken);
          context.commit('SAVE_APPLICATION_ID', response.data?.applicationId);
          context.commit("REMOVE_LOG", { request: "referralStartForGPay" });
          resolve(response.data);
        })
        .catch(err => {
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
          context.commit("REMOVE_LOG", { request: "referralStartForGPay" });
        });
    });
  },
  HomeGPayFetchDetails(context) {
    context.commit('ADD_LOG', { request: 'HomeGPayFetchDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('HomeGPayFetchDetails'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('SAVE_DATA', response.data);
          context.commit('FLAGS_DATA', response.data);
          context.commit('REMOVE_LOG', { request: 'HomeGPayFetchDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'HomeGPayFetchDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayShortReferral(context, params) {
    context.commit('ADD_LOG', { request: 'gPayShortReferral' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('gPayShortReferral'), params.patchParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayShortReferral' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayShortReferral' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayMarketplaceDocument(context, params) {
    context.commit('ADD_LOG', { request: 'gPayMarketplaceDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('gPayMarketplaceDocument', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayMarketplaceDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayMarketplaceDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPaySuppliers(context, params) {
    context.commit('ADD_LOG', { request: 'gPaySuppliers' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('gPaySuppliers'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPaySuppliers' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPaySuppliers' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  transactionSupplier(context, params) {
    context.commit('ADD_LOG', { request: 'transactionSupplier' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('transactionSupplier', params.marketplaceId), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'transactionSupplier' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'transactionSupplier' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayPaymentDetails(context, params) {
    context.commit('ADD_LOG', { request: 'gPayPaymentDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gPayPaymentDetails'), params.formData, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayPaymentDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayPaymentDetails' });
          context.dispatch('resolveError', { err, hideError: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayProcessPayment(context, params) {
    context.commit('ADD_LOG', { request: 'gPayProcessPayment' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gPayProcessPayment'), params, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayProcessPayment' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayProcessPayment' });
          context.dispatch('resolveError', { err, hideError: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayResendPaymentOtp(context, params) {
    context.commit('ADD_LOG', { request: 'gPayResendPaymentOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gPayResendPaymentOtp'), params, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayResendPaymentOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayResendPaymentOtp' });
          context.dispatch('resolveError', { err, hideError: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayVerifyPaymentOtp(context, params) {
    context.commit('ADD_LOG', { request: 'gPayVerifyPaymentOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gPayVerifyPaymentOtp'), params, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayVerifyPaymentOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayVerifyPaymentOtp' });
          context.dispatch('resolveError', { err, errorCode: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayPaymentDetailsTransaction(context, params) {
    context.commit('ADD_LOG', { request: 'gPayPaymentDetailsTransaction' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('gPayPaymentDetailsTransaction', params.transactionId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('Customer_Transaction', response?.data);
          context.commit('REMOVE_LOG', { request: 'gPayPaymentDetailsTransaction' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayPaymentDetailsTransaction' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayIsUserBlocked(context) {
    context.commit('ADD_LOG', { request: 'gPayIsUserBlocked' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('gPayIsUserBlocked'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('Customer_Transaction', response?.data);
          context.commit('REMOVE_LOG', { request: 'gPayIsUserBlocked' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayIsUserBlocked' });
          context.dispatch('resolveError', { err, errorCode: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayPendingSupplier(context, params) {
    context.commit('ADD_LOG', { request: 'gPayPendingSupplier' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('gPayPendingSupplier'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('Customer_Transaction', response?.data);
          context.commit('REMOVE_LOG', { request: 'gPayPendingSupplier' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayPendingSupplier' });
          context.dispatch('resolveError', { err, errorCode: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gPayV2OnboardingLink(context, params) {
    context.commit('ADD_LOG', { request: 'gPayV2OnboardingLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('gPayV2OnboardingLink'), params, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gPayV2OnboardingLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gPayV2OnboardingLink' });
          context.dispatch('resolveError', { err, errorCode: true })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  currentAddress(context, params) {
    context.commit('ADD_LOG', { request: 'currentAddress' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('currentAddress', params.applicationId), params.body, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'currentAddress' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'currentAddress' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  aadharAddress(context, params) {
    context.commit('ADD_LOG', { request: 'aadharAddress' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('aadharAddress', params.applicationId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'aadharAddress' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'aadharAddress' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
